import { maybeRetrieveData } from 'services/autofill'

export default ((eventType) => (dispatch, getState) => dispatch({
  type: 'RETRIEVE_AUTOFILL_DATA',
  data: maybeRetrieveData(getState(), eventType)
}))
